"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var errors_1 = require("./errors");
var utils_1 = require("./utils");
/**
 * Type describing a link session that can create a eosjs compatible
 * signature provider and transact for a specific auth.
 */
var LinkSession = /** @class */ (function () {
    function LinkSession() {
    }
    /** Restore a previously serialized session. */
    LinkSession.restore = function (link, data) {
        switch (data.type) {
            case 'channel':
                return new LinkChannelSession(link, data);
            case 'fallback':
                return new LinkFallbackSession(link, data);
            default:
                throw new Error('Unable to restore, session data invalid');
        }
    };
    return LinkSession;
}());
exports.LinkSession = LinkSession;
/**
 * Link session that pushes requests over a channel.
 */
var LinkChannelSession = /** @class */ (function (_super) {
    __extends(LinkChannelSession, _super);
    function LinkChannelSession(link, data) {
        var _this = _super.call(this) || this;
        _this.timeout = 2 * 60 * 1000; // ms
        _this.link = link;
        _this.auth = data.auth;
        _this.publicKey = data.publicKey;
        _this.channel = data.channel;
        _this.encrypt = function (request) {
            return utils_1.sealMessage(request.encode(true, false), data.requestKey, data.channel.key);
        };
        _this.serialize = function () { return (__assign({ type: 'channel' }, data)); };
        return _this;
    }
    LinkChannelSession.prototype.onSuccess = function (request, result) {
        if (this.link.transport.onSuccess) {
            this.link.transport.onSuccess(request, result);
        }
    };
    LinkChannelSession.prototype.onFailure = function (request, error) {
        if (this.link.transport.onFailure) {
            this.link.transport.onFailure(request, error);
        }
    };
    LinkChannelSession.prototype.onRequest = function (request, cancel) {
        var info = {
            expiration: new Date(Date.now() + this.timeout).toISOString().slice(0, -1),
        };
        if (this.link.transport.onSessionRequest) {
            this.link.transport.onSessionRequest(this, request, this.timeout, this.channel.name, cancel);
        }
        setTimeout(function () {
            cancel(new errors_1.SessionError('Wallet did not respond in time', 'E_TIMEOUT'));
        }, this.timeout + 500);
        request.data.info.push({
            key: 'link',
            value: utils_1.abiEncode(info, 'link_info'),
        });
        this.link.rpc
            .fetchBuiltin(this.channel.url, {
            method: 'POST',
            headers: {
                'X-Buoy-Wait': (this.timeout / 1000).toFixed(0),
            },
            body: this.encrypt(request),
        })
            .then(function (response) {
            if (response.status !== 200) {
                cancel(new errors_1.SessionError('Unable to push message', 'E_DELIVERY'));
            }
            else {
                // request delivered
            }
        })
            .catch(function (error) {
            cancel(new errors_1.SessionError("Unable to reach link service (" + (error.message || String(error)) + ")", 'E_DELIVERY'));
        });
    };
    LinkChannelSession.prototype.makeSignatureProvider = function () {
        return this.link.makeSignatureProvider([this.publicKey], this);
    };
    LinkChannelSession.prototype.transact = function (args) {
        return this.link.transact(args, this);
    };
    return LinkChannelSession;
}(LinkSession));
exports.LinkChannelSession = LinkChannelSession;
var LinkFallbackSession = /** @class */ (function (_super) {
    __extends(LinkFallbackSession, _super);
    function LinkFallbackSession(link, data) {
        var _this = _super.call(this) || this;
        _this.link = link;
        _this.auth = data.auth;
        _this.publicKey = data.publicKey;
        _this.serialize = function () { return (__assign({ type: 'fallback' }, data)); };
        return _this;
    }
    LinkFallbackSession.prototype.transact = function (args) {
        return this.link.transact(args);
    };
    LinkFallbackSession.prototype.makeSignatureProvider = function () {
        return this.link.makeSignatureProvider([this.publicKey]);
    };
    return LinkFallbackSession;
}(LinkSession));
exports.LinkFallbackSession = LinkFallbackSession;
//# sourceMappingURL=link-session.js.map